module.exports = __webpack_public_path__ + "media/images/invoice-template-air-41ca77e261dea97e770fdb0e12c9cb0b.png";